import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import policy from '../services/PolicyService';
import { policy_slice_name, policy_thunks } from '../constants/policy';
import { normaliseApi } from '../utilities/policy/normalise';

const initialState = {
  loading: false,
  policyDetails: null,
  error: null,
};

export const getPolicyDetails = createAsyncThunk(
  policy_thunks.POLICY_GET_POLICY_DETAILS,
  async ({ policyHolderId, adviserId }, { rejectWithValue }) => {
    try {
      const response = await policy.getPolicyDetails(policyHolderId, adviserId);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getPolicyDocument = createAsyncThunk(
  policy_thunks.POLICY_GET_POLICY_DOCUMENT,
  async ({ documentId, fileName, adviserId }, { rejectWithValue }) => {
    try {
      const response = await policy.getPolicyDocument(
        documentId,
        fileName,
        adviserId
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const policySlice = createSlice({
  name: policy_slice_name,
  initialState,
  reducers: {
    reset() {
      return initialState;
    },
  },
  extraReducers: {
    [getPolicyDetails.pending]: (state) => {
      state.loading = true;
      state.error = false;
    },
    [getPolicyDetails.fulfilled]: (state, action) => {
      state.loading = false;
      if (action.payload?.data?.data) {
        state.policyDetails = normaliseApi(action.payload.data);
      } else {
        state.error =
          'Sorry, we’re unable to show your cover details at this moment. Please try again later.';
      }
    },
    [getPolicyDetails.rejected]: (state, action) => {
      state.error = action.error.message;
      state.loading = false;
    },
  },
});

export const { reset } = policySlice.actions;

export default policySlice;
